import type { DefaultTypedEditorState } from '@payloadcms/richtext-lexical'

export type FaqItemData = {
  answer: DefaultTypedEditorState
  category: string
  id: string
  question: string
}

export type FaqSectionData = {
  categoryLabels: Record<string, string>
  categoryOrder: string[]
  items: FaqItemData[]
}

export const FAQ_ALL_CATEGORY = 'all'
